if (!customElements.get('elmuno-shop-header')) {
  customElements.define('elmuno-shop-header', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.toggleButton = this.querySelector('[data-es-toggle]');
      this.navigation = this.querySelector('[data-es-nav]');
      this.disclosures = [...this.querySelectorAll('[data-es-disclosure]')];
      this.mobileQuery = window.matchMedia('(max-width: 1099px)');
      this.classList.add('es-header--ready');
      this.toggleButton.addEventListener('click', () => {
        this.setMenu(this.toggleButton.getAttribute('aria-expanded') !== 'true', true);
      }, options);
      this.disclosures.forEach((details) => {
        details.addEventListener('toggle', () => {
          if (details.open) this.disclosures.forEach((other) => { if (other !== details) other.open = false; });
        }, options);
      });
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const expanded = event.target.closest('[data-es-disclosure][open]');
        if (expanded) {
          expanded.open = false;
          expanded.querySelector('summary').focus();
        } else if (this.toggleButton.getAttribute('aria-expanded') === 'true') {
          this.setMenu(false, true);
        } else {
          this.disclosures.forEach((details) => { details.open = false; });
        }
        event.stopPropagation();
      }, options);
      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
      }, options);
      this.navigation.addEventListener('click', (event) => {
        if (event.target.closest('a')) this.close();
      }, options);
      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) this.close();
      }, options);
      this.mobileQuery.addEventListener('change', (event) => {
        const returnFocus = event.matches && this.navigation.contains(document.activeElement);
        this.close();
        if (returnFocus) this.toggleButton.focus();
      }, options);
    }
    disconnectedCallback() {
      this.abortController?.abort();
    }
    setMenu(open, manageFocus = false) {
      this.toggleButton.setAttribute('aria-expanded', String(open));
      this.toggleButton.setAttribute('aria-label', open ? this.toggleButton.dataset.labelClose : this.toggleButton.dataset.labelOpen);
      this.classList.toggle('es-header--open', open);
      if (!open) this.disclosures.forEach((details) => { details.open = false; });
      if (manageFocus) {
        if (open) this.navigation.querySelector('a, summary')?.focus();
        else this.toggleButton.focus();
      }
    }
    close() {
      this.setMenu(false);
    }
  });
}
